// src/services/axios.ts
import axios from "axios";
import {
  logoutHandler,
  navigateHandler,
  showWarningToastHandler,
} from "./axiosHandlers";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const location = localStorage.getItem("location_zip");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (location) {
    config.headers["x-location"] = location;
  }
  config.headers["x-api-key"] = process.env.REACT_APP_API_KEY;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      error.response.data?.message === "Unauthorized"
    ) {
      console.warn("Unauthorized - Logging out...");
      logoutHandler();
      showWarningToastHandler("Session expired. Please log in again.");
      navigateHandler("/login");
    }
    return Promise.reject(error);
  }
);

export default api;
